<template>
  <header v-if="!isChat">
    <b-navbar toggleable="md" type="light" variant="light">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

     <b-navbar-brand href="/">NEXTV
       <span class="header-badge badge badge-pill badge-secondary">{{ service }}</span>
     </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav>
          <live-status class="mr-1" v-if="rid && !isAssistBoard"></live-status>
          <live-controls v-if="isCast || isWatch"></live-controls>
          <studio-settings v-if="isStudio"></studio-settings>
          <studio-controls v-if="isStudio"></studio-controls>
          <studio-status v-if="rid && !isAssistBoard"></studio-status>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <button
              v-if="isSignIn && !isCast && !isWatch && !isStudio && !isAssistBoard && !isChatConfig"
              class="btn mr-3"
              @click.stop.prevent="$router.push({ name: 'chatOption', params: { mode: 'prod' }})">
              채팅-prod
            </button>
            <button
              v-if="isSignIn && !isCast && !isWatch && !isStudio && !isAssistBoard && !isChatConfig"
              class="btn mr-3"
              @click.stop.prevent="$router.push({ name: 'chatOption', params: { mode: 'test' }})">
              채팅-test
            </button>
            <button
              v-if="isSignIn && !isCast && !isWatch && !isStudio && !isAssistBoard && !isChatConfig"
              class="btn mr-3"
              @click.stop.prevent="$router.push({ name: 'quiz'})">
              퀴즈만들기
            </button>
            <button
              v-if="isSignIn && !isCast && !isWatch && !isStudio && !isAssistBoard && !isChatConfig"
              class="btn mr-3"
              v-b-modal="'castCreateModal'"
              @click.stop.prevent>
              🎬  방송만들기
            </button>

            <sign-toggle-btn></sign-toggle-btn>
          </b-nav-form>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <cast-create-modal
      v-if="isSignIn && !isCast && !isWatch && !isStudio && !isAssistBoard">
    </cast-create-modal>
    <v-dialog/> <!-- global alert -->
  </header>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import SignToggleBtn from '@/components/user/SignToggleBtn'
import CastCreateModal from '@/components/live/CastCreateModal'
import LiveStatus from '@/components/live/LiveStatus'
import LiveControls from '@/components/live/LiveControls'
import StudioControls from '@/components/studio/StudioControls'
import StudioStatus from '@/components/studio/StudioStatus'
import Config from '@/components/studio/Config'
import l from '@/vendor/logger'

l.d('Header/env', process.env.VUE_APP_SERVICE)

export default {
  name: 'HomeHeader',

  computed: {
    ...mapState([
      'rid'
    ]),
    ...mapGetters('user', [
      'isSignIn'
    ]),
    ...mapGetters('room', [
      'isCast',
      'isWatch',
      'isStudio',
      'isAssistBoard',
      'isChatConfig'
    ]),
    service () {
      return process.env.VUE_APP_SERVICE
    },
    isChat () {
      if (this.$route.name === 'chat') { return true }
    }
  },

  components: {
    SignToggleBtn,
    CastCreateModal,
    LiveStatus,
    LiveControls,
    StudioControls,
    StudioStatus,
    'studio-settings': Config
  }
}
</script>

<style scoped>
.header-badge {
  font-size: .3rem;
  font-weight: lighter;
}
</style>
